const blockInvalidChar = e => ['e', 'E', '+', '-'].includes(e.target.value);

export default {
    blockInvalidChar
};
